import { SelectBox } from "devextreme-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Pagination = ({
  dataDisplayCount,
  setpagecount,
  pagecount,
  page_limit,
  setlast,
  last,
  setfirtst,
  firtst,
  setpage_limit,
}) => {
  const [length, setlength] = useState(
    Math.ceil(Number(dataDisplayCount) / page_limit)
  );
  const [length2, setlength2] = useState(
    Math.ceil(Number(dataDisplayCount) / page_limit)
  );
  const [pages, setpages] = useState(
    new Array(length > 5 ? 5 : length).fill("1")
  );

  useEffect(() => {
    setlength(Math.ceil(Number(dataDisplayCount) / page_limit));
    setlength2(Math.ceil(Number(dataDisplayCount) / page_limit));
    setpages(
      new Array(
        Math.ceil(Number(dataDisplayCount) / page_limit) > 5
          ? 5
          : Math.ceil(Number(dataDisplayCount) / page_limit)
      ).fill("1")
    );
  }, [dataDisplayCount, page_limit]);
  const [count, setcount] = useState(0);

  return (
    <>
      <div className="pagination">
        <div style={{ justifyContent: "right" }} className="pagination__flex">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: 'auto',
              marginRight: '-6%'
            }}
          >
            <p style={{ fontSize: "14px" }}>Rows per page:</p>
            <SelectBox
              dataSource={[
                { name: 10 },
                { name: 20 },
                { name: 30 },
                { name: 50 },
              ]}
              valueExpr="name"
              value={page_limit}
              displayExpr="name"
              searchEnabled={false}
              searchExpr={"name"}
              dropDownOptions={{ height: "140px" }}
              style={{ marginLeft: "10px", width: "25%" }}
              onItemClick={(e) => {
                setpage_limit(e?.itemData?.name);
                setlast(e?.itemData?.name);
                setfirtst(0);
                setpagecount(1);
              }}
            />

            <p className="para" style={{ marginLeft: "20px" }}>
              <span style={{ fontSize: "14px" }}>
                {firtst}-{last > dataDisplayCount ? dataDisplayCount : last} of{" "}
                {dataDisplayCount}
              </span>
            </p>
          </div>
          <div style={{ marginLeft: "20px" }} className="pagination__item">
            {pages?.length ? (
              <ul className="pagination__paging">
                <li
                  onClick={() => {
                    if (pagecount > 1) {
                      if (pagecount > 1 + count) {
                        setfirtst(firtst - page_limit);
                        setlast(last - page_limit);
                        setpagecount(pagecount - 1);
                      } else {
                        setpagecount(pagecount - 1);
                        setfirtst(firtst - page_limit);
                        setlast(last - page_limit);
                        setlength2(length2 + 5);
                        setcount(count - 5);
                        setpages(
                          new Array(length2 + 5 > 5 ? 5 : length2 + 5).fill("1")
                        );
                      }
                    }
                  }}
                  className="pagination__paging__item"
                >
                  <Link className="pagination__link pagination__link--previous" href="#">
                    <svg
                      width={20}
                      height={20}
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L9.41421 10L12.7071 13.2929C13.0976 13.6834 13.0976 14.3166 12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z"
                        fill="#334155"
                      />
                    </svg>
                  </Link>
                </li>

                {pages?.map((val, i) => (
                  <li
                    key={i} 
                    className="pagination__paging__item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setpagecount(i + 1 + count);
                      setlast((i + 1 + count) * page_limit);
                      setfirtst((i + 1 + count) * page_limit - page_limit);
                    }}
                  >
                    <Link
                      className={`pagination__link pagination__link${i + 1 + count === pagecount ? "--active" : ""}`}
                    >
                      {i + 1 + count}
                    </Link>
                  </li>
                ))}

                <li
                  onClick={() => {
                    if (length < pagecount + 1) {
                      return;
                    }
                    if (pagecount < pages?.length + count) {
                      setlast(last + page_limit);
                      setfirtst(firtst + page_limit);
                      setpagecount(pagecount + 1);
                    } else {
                      setpagecount(pagecount + 1);
                      setlast(last + page_limit);
                      setfirtst(firtst + page_limit);
                      setlength2(length2 - 5);
                      setcount(count + 5);
                      setpages(
                        new Array(length2 - 5 > 5 ? 5 : length2 - 5).fill("1")
                      );
                    }
                  }}
                  className="pagination__paging__item"
                >
                  <Link className="pagination__link pagination__link--next" href="#">
                    <svg
                      width={20}
                      height={20}
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z"
                        fill="#334155"
                      />
                    </svg>
                  </Link>
                </li>
              </ul>
            ) : null}
          </div>

        </div>
      </div>
    </>
  );
};
